
<template>
  <div class="footer-container" :class="{'can-subscribe': isCanSubscribe, 'footer-container-tab':fromTab}">
    <div class="btn-container">
  <!-- 支付时显示气泡 -->
  <div class="bubble">
    <Bubble :bubbleContent="bubbleContent" />
  </div>
  <rich-button  @click="goBuy">
    <div class="price">
      <div class="price-box">
        {{ btnText }}
        <div class="del" v-if="delPrice">{{ delPrice }}</div>
      </div>
    </div>
  </rich-button>
  <!-- <div 
    v-if="isCanSubscribe" 
    class="subscribe-rule" 
    v-html="ruleText"
    @click="openRule"></div> -->
</div>
  </div>
</template>
<script>
import Bubble from '@/components/bubble/index.vue'
import { mapState } from 'vuex'
export default {
  name: 'Footer',
  props: ['priceText', 'productId', 'price', 'bubbleContent', 'delPrice', 'isCanSubscribe', 'noSubscriptionStatus', 'fromTab'],
  components: {
    Bubble,
  },
  computed:{
    ...mapState(['brandName']),
    btnText(){
      // 能订阅
      if(this.isCanSubscribe) {
        // 未订阅
        if(this.noSubscriptionStatus) {
          return this.$t('FoodC_subscription_YJLt_vjMk', {
          didipackbrand: this.brandName
        }) + ' ' + this.priceText
        } else {
          // 已经订阅
          return ''
        }
        
      }
      return this.$t("FoodC_C_Only_money_ZEKz", { money: this.priceText })
    },
    ruleText(){
      const rule = this.$t('FoodC_subscription_VPMP_seXT')
      const text = `<span class="subscribe-rule-info">${rule}</span>`
      return this.$t('FoodC_subscription_StNY_sWmE', {rules: text})
    }
  },
  methods: {
    goBuy () {
      this.$emit('goBuy', {type:'MEMBER'})
    },
    openRule() {
      this.$emit('openRule')
    }
  }

}
</script>
<style lang="scss" scoped>

.footer-container{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px -10px 48px 0px rgba(0,0,0,0.06);
  padding: 36px 24px 71px 24px;
  box-sizing: border-box;
  border-radius: 40px 40px 0 0;
}

.btn-container {
  position: relative;
  .rich-btn {
    height: 108px;
  }
}

.bubble {
  position: absolute;
  right: 0;
  top: -20px;
}
.price {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .price-box {
    position: relative;
    width: fit-content;
    height: fit-content;
    .del {
      position: absolute;
      left: 100%;
      bottom: 0;
      height: 22px;
      opacity: 0.8;
      font-family: DiDiSans-Pro-Bold;
      font-size: 22px;
      color: #FFFFFF;
      line-height: 22px;
      text-decoration: line-through;
      margin-left: 8.5px
    }
  }
}

.footer-container-tab{
  padding: 32px 24px;
  .btn-container {
  .rich-btn {
      height: 92px;
    }
  }
}
</style>